module.exports = __webpack_public_path__ + "img/avatar-nathaliaduraes_.b6fcdf20.jpg";